/**
 * Combines repeated invoice lines for printing.
 * Lines are merged only when they share the same item, rate, GST % and unit,
 * so qty × rate always equals the printed amount. Same item at different rates
 * stays on separate rows. Order follows each group's first appearance.
 */

const round2 = (n) => Math.round(Number(n || 0) * 100) / 100;
const round3 = (n) => Math.round(Number(n || 0) * 1000) / 1000;

const SUM_FIELDS = ["lineSubtotal", "lineGst", "lineTotal", "cgst", "sgst", "igst"];

export function mergeLineItemsForPrint(lineItems = []) {
  const groups = new Map();

  lineItems.forEach((li) => {
    const key = [
      li.itemId || String(li.itemName || "").trim().toLowerCase(),
      Number(li.rate || 0),
      Number(li.gstPercent || 0),
      li.unit || ""
    ].join("|");

    const existing = groups.get(key);
    if (!existing) {
      groups.set(key, { ...li });
      return;
    }

    existing.qty = round3(Number(existing.qty || 0) + Number(li.qty || 0));
    SUM_FIELDS.forEach((field) => {
      if (existing[field] !== undefined || li[field] !== undefined) {
        existing[field] = round2(Number(existing[field] || 0) + Number(li[field] || 0));
      }
    });
  });

  return [...groups.values()];
}

export default mergeLineItemsForPrint;
